<script>
export default {};
</script>

<template>
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style="enable-background:new 0 0 512 512;"
    xml:space="preserve"
  >
    <path
      style="fill:#FAE17C;"
      d="M404.609,74.86l-6.366-17.902c-2.274-6.396,2.583-13.082,9.369-12.895l18.993,0.523
	c2.221,0.061,4.396-0.645,6.158-2l15.058-11.587c5.38-4.14,13.24-1.586,15.159,4.926l5.373,18.224
	c0.629,2.132,1.972,3.981,3.806,5.238l15.673,10.741c5.6,3.838,5.6,12.102,0,15.939l-15.673,10.741
	c-1.833,1.256-3.177,3.106-3.806,5.238l-5.373,18.224c-1.92,6.511-9.779,9.065-15.159,4.926l-15.058-11.587
	c-1.761-1.355-3.936-2.062-6.158-2l-18.993,0.523c-6.786,0.187-11.643-6.499-9.369-12.895l6.366-17.902
	C405.353,79.24,405.353,76.953,404.609,74.86z"
    />
    <path
      style="fill:#FF85B6;"
      d="M29.96,286.424l-17.159-8.157c-6.131-2.915-7.424-11.077-2.494-15.743l13.799-13.06
	c1.614-1.527,2.652-3.565,2.939-5.769l2.455-18.84c0.877-6.732,8.241-10.484,14.202-7.236l16.685,9.088
	c1.952,1.063,4.21,1.42,6.395,1.012l18.677-3.487c6.674-1.246,12.516,4.597,11.271,11.271l-3.487,18.677
	c-0.408,2.185-0.051,4.443,1.012,6.395l9.088,16.685c3.247,5.961-0.504,13.325-7.236,14.202l-18.84,2.455
	c-2.203,0.288-4.241,1.325-5.769,2.939l-13.06,13.799c-4.666,4.931-12.828,3.637-15.743-2.493l-8.157-17.159
	C33.584,288.995,31.967,287.378,29.96,286.424z"
    />
    <path
      style="fill:#A3E3FF;"
      d="M456.803,387.885l-15.793,4.483c-5.643,1.601-11.135-2.962-10.592-8.803l1.519-16.347
	c0.178-1.912-0.31-3.827-1.379-5.422l-9.143-13.636c-3.267-4.872-0.623-11.505,5.1-12.794l16.016-3.607
	c1.873-0.422,3.544-1.477,4.73-2.987l10.143-12.91c3.624-4.613,10.749-4.148,13.743,0.897l8.381,14.118
	c0.98,1.652,2.5,2.915,4.302,3.576l15.412,5.657c5.507,2.021,7.266,8.942,3.395,13.348l-10.837,12.333
	c-1.268,1.443-1.999,3.278-2.071,5.197l-0.618,16.405c-0.221,5.861-6.259,9.674-11.646,7.354l-15.077-6.496
	C460.622,387.49,458.651,387.362,456.803,387.885z"
    />
    <path
      style="fill:#498A68;"
      d="M355.635,347.492c-4.391,0-8.359-0.924-11.533-2.911c-7.128-4.461-9.29-13.856-4.829-20.984
	c3.688-5.893,10.745-8.392,17.112-6.56c3.339-0.498,11.589-3.477,17.372-11.014c5.12-6.672,14.677-7.93,21.35-2.81
	c6.671,5.12,7.929,14.678,2.81,21.35C387.268,338.437,369.38,347.492,355.635,347.492z"
    />
    <path
      style="fill:#5CB38E;"
      d="M254.474,410.185c-70.608,7.954-151.864,17.107-215.627-14.17
	c-10.911-5.352-6.792-21.711,5.358-21.461c47.816,0.982,86.034-15.466,106.409-37.433L254.474,410.185z"
    />
    <path
      style="opacity:0.1;enable-background:new    ;"
      d="M125.784,356.146c3.328,22.46,9.324,44.578,25.332,61.728
	c34.861,0.028,70.278-3.962,103.358-7.688l-103.86-73.064C144.083,344.162,135.711,350.632,125.784,356.146z"
    />
    <g>
      <path
        style="fill:#498A68;"
        d="M224.911,483.005c-9.047,0-17.663-5.271-21.497-14.097c-14.595-33.597-6.449-76.351,5.815-92.213
		c7.913-10.236,22.625-12.115,32.86-4.204c10.056,7.775,12.049,22.113,4.609,32.32c-2.951,5.583-7.466,28.966-0.314,45.43
		c5.155,11.865-0.286,25.663-12.152,30.818C231.193,482.38,228.026,483.005,224.911,483.005z M246.302,405.338
		c-0.004,0.004-0.007,0.009-0.01,0.013C246.296,405.347,246.299,405.343,246.302,405.338z M246.809,404.61L246.809,404.61
		L246.809,404.61z"
      />
      <path
        style="fill:#498A68;"
        d="M343.181,464.502c-0.761,0-1.528-0.037-2.3-0.112c-12.876-1.255-22.297-12.711-21.043-25.587
		c1.42-14.576-12.485-32.809-18.787-35.995c-12.187-2.566-20.309-14.3-18.271-26.714c2.095-12.766,14.145-21.417,26.91-19.321
		c20.26,3.326,35.379,22.839,40.938,31.073c6.934,10.272,18.213,31.14,15.839,55.499
		C365.288,455.451,355.094,464.502,343.181,464.502z M302.087,403.004c0.005,0.001,0.01,0.002,0.015,0.002
		C302.096,403.006,302.091,403.005,302.087,403.004z"
      />
    </g>
    <path
      style="opacity:0.1;enable-background:new    ;"
      d="M361.394,408.557c-3.306-8.745-7.513-15.892-10.765-20.708
	c-5.56-8.235-20.678-27.747-40.938-31.073c-12.765-2.096-24.815,6.555-26.91,19.321c-2.037,12.413,6.085,24.148,18.271,26.714
	c5.489,2.775,16.746,16.968,18.618,30.216C337.323,426.98,351.081,418.898,361.394,408.557z"
    />
    <path
      style="opacity:0.1;enable-background:new    ;"
      d="M244.794,445.848c-4.79-15.968-0.792-35.934,1.904-41.036
	c7.44-10.207,5.447-24.544-4.609-32.32c-10.234-7.912-24.946-6.032-32.86,4.204c-9.189,11.884-16.064,38.863-12.797,65.776
	c10.804,2.45,22.904,3.669,36.374,3.669C236.647,446.14,240.649,446.042,244.794,445.848z"
    />
    <path
      style="fill:#5CB38E;"
      d="M359.767,315.153c6.122,54.343,3.17,94.496-95.723,105.637
	c-98.894,11.141-110.705-27.35-116.826-81.693c-6.122-54.343,36.497-103.757,95.191-110.368
	C301.102,222.117,353.646,260.81,359.767,315.153z"
    />
    <path
      style="fill:#9BDFC1;"
      d="M359.767,315.153c-0.049-0.433-0.109-0.862-0.163-1.293c-22.775-3.187-66.867,0.107-93.764,36.019
	c-19.6,26.17-19.945,52.067-15.263,72.161c4.3-0.309,8.785-0.724,13.466-1.251C362.937,409.649,365.889,369.496,359.767,315.153z"
    />
    <path
      style="opacity:0.05;enable-background:new    ;"
      d="M222.433,232.779c-48.061,14.253-80.618,58.363-75.216,106.317
	c5.668,50.319,16.227,87.04,96.268,83.359C194.33,382.651,192.448,289.244,222.433,232.779z"
    />
    <path
      style="fill:#5CB38E;"
      d="M331.789,77.242L331.789,77.242c-19.881-26.476-51.719-41.211-84.769-39.232l-40.627,2.433
	c-57.759,3.459-101.778,53.086-98.319,110.846l2.88,48.084c3.105,51.839,47.645,91.346,99.483,88.241l215.362-12.897
	c38.834-2.326,68.429-35.692,66.103-74.525l-1.96-32.725c-2.326-38.834-35.692-68.429-74.525-66.103l-27.899,1.671
	C365.79,104.334,344.859,94.648,331.789,77.242z"
    />
    <g style="opacity:0.1;">
      <circle cx="169.136" cy="218.83" r="7.211" />
      <circle cx="220.958" cy="226.738" r="7.211" />
      <circle cx="193.152" cy="253.048" r="7.211" />
    </g>
    <g>
      <ellipse
        transform="matrix(-0.0598 -0.9982 0.9982 -0.0598 65.0684 300.7617)"
        style="fill:#FFA8CB;"
        cx="174.176"
        cy="119.737"
        rx="9.324"
        ry="18.174"
      />

      <ellipse
        transform="matrix(0.0598 0.9982 -0.9982 0.0598 390.5281 -189.7212)"
        style="fill:#FFA8CB;"
        cx="295.978"
        cy="112.451"
        rx="9.324"
        ry="18.174"
      />
    </g>
    <path
      style="opacity:0.05;enable-background:new    ;"
      d="M183.314,44.429c-45.943,13.356-78.222,57.087-75.241,106.86l2.88,48.084
	c3.105,51.839,47.645,91.346,99.483,88.241l56.956-3.411C181.554,240.908,159.549,109.085,183.314,44.429z"
    />
    <path
      style="fill:#495059;"
      d="M409.799,240.758L409.799,240.758c-13.052,0.781-24.265-9.166-25.047-22.216l-0.6-10.03
	c-0.45-7.512,5.275-13.966,12.787-14.416l20.06-1.202c7.512-0.45,13.966,5.275,14.417,12.787l0.6,10.03
	C432.797,228.762,422.851,239.976,409.799,240.758z"
    />
    <path
      style="fill:#498A68;"
      d="M270.674,383.583c-6.755,0-12.924-4.528-14.718-11.369c-1.939-7.396-7.153-10.149-13.767-12.979
	c-1.831-0.784-3.562-1.524-5.252-2.582c-7.128-4.461-9.29-13.856-4.829-20.984c4.377-6.994,13.504-9.207,20.579-5.074
	c0.408,0.194,0.911,0.4,1.482,0.644c6.939,2.969,25.371,10.856,31.243,33.253c2.133,8.134-2.733,16.457-10.867,18.59
	C273.251,383.421,271.952,383.583,270.674,383.583z M252.875,330.706c0.073,0.044,0.146,0.089,0.218,0.134
	C253.026,330.797,252.953,330.753,252.875,330.706z"
    />
    <path
      d="M511.517,344.093c-1.272-5-4.922-9.047-9.766-10.824l-15.412-5.656c-0.228-0.084-0.423-0.245-0.547-0.455l-8.381-14.118
	c-2.633-4.436-7.28-7.286-12.428-7.621c-5.145-0.337-10.124,1.886-13.311,5.943l-10.142,12.909c-0.151,0.191-0.364,0.326-0.602,0.38
	l-16.016,3.607c-5.033,1.134-9.178,4.672-11.088,9.464c-1.91,4.793-1.335,10.212,1.538,14.497l9.144,13.636
	c0.135,0.202,0.197,0.447,0.175,0.689l-1.519,16.347c-0.477,5.138,1.607,10.173,5.575,13.47c3.968,3.298,9.299,4.426,14.262,3.017
	l15.793-4.482c0.233-0.067,0.486-0.051,0.711,0.046l15.077,6.496c1.984,0.854,4.088,1.277,6.186,1.277
	c2.913,0,5.812-0.814,8.348-2.416c4.362-2.754,7.082-7.477,7.276-12.632l0.618-16.406c0.009-0.243,0.102-0.477,0.263-0.661
	l10.838-12.333C511.515,354.391,512.788,349.093,511.517,344.093z M497.162,348.648l-10.837,12.332
	c-2.367,2.693-3.744,6.15-3.879,9.733l-0.618,16.405c-0.015,0.371-0.181,0.66-0.495,0.858c-0.314,0.199-0.645,0.225-0.987,0.078
	l-15.078-6.497c-1.964-0.845-4.075-1.273-6.192-1.273c-1.434,0-2.87,0.196-4.262,0.591c0,0.001-0.001,0.001-0.001,0.001
	l-15.793,4.483c-0.357,0.101-0.683,0.032-0.969-0.205c-0.286-0.238-0.413-0.545-0.379-0.915l1.518-16.348
	c0.331-3.57-0.586-7.177-2.582-10.154l-9.143-13.635c-0.207-0.308-0.242-0.64-0.104-0.985c0.137-0.345,0.391-0.562,0.753-0.643
	l16.015-3.607c3.498-0.788,6.644-2.774,8.86-5.594l10.142-12.91c0.229-0.291,0.532-0.43,0.905-0.403
	c0.37,0.024,0.655,0.198,0.844,0.518l8.38,14.117c1.829,3.084,4.692,5.462,8.058,6.698l15.412,5.656
	c0.349,0.128,0.572,0.376,0.664,0.735C497.485,348.044,497.407,348.369,497.162,348.648z M399.542,297.432
	c-9.848-7.557-24.009-5.693-31.565,4.155c-0.82,1.069-1.7,1.998-2.595,2.816c-1.364-6.323-3.342-12.473-5.911-18.416l66.764-3.999
	c42.782-2.562,75.504-39.452,72.942-82.234l-1.96-32.725c-1.212-20.238-10.067-38.818-24.945-52.509l3.071-10.416
	c0.154-0.522,0.486-0.979,0.935-1.287l15.672-10.74c4.613-3.161,7.367-8.388,7.367-13.981c0-5.592-2.754-10.818-7.367-13.981
	l-15.672-10.739c-0.449-0.308-0.781-0.765-0.936-1.287l-5.373-18.224c-1.581-5.364-5.7-9.598-11.019-11.326
	c-5.319-1.727-11.141-0.725-15.573,2.686L428.319,36.81c-0.432,0.332-0.973,0.506-1.515,0.493l-18.993-0.523
	c-5.575-0.154-10.89,2.455-14.178,6.98c-3.288,4.524-4.131,10.371-2.257,15.641l6.367,17.903c0.182,0.513,0.182,1.077-0.001,1.59
	l-5.896,16.582l-4.764,0.286c-19.341,1.152-37.832-7.4-49.466-22.893c-21.409-28.512-55.433-44.261-91.032-42.13l-40.626,2.433
	C144.281,36.864,97.106,90.048,100.8,151.725l2.88,48.084c2.021,33.735,20.762,63.373,48.242,80.301
	c-9.759,17.808-13.935,37.465-12.164,57.407c-21.935,19.458-57.244,30.533-95.404,29.753c-8.986-0.189-16.459,5.554-18.579,14.281
	c-2.1,8.643,1.863,17.086,9.862,21.009c36.654,17.98,77.93,22.651,115.378,22.651c13.056-0.001,25.639-0.57,37.405-1.341
	c-0.504,13.279,0.86,30.794,8.31,47.944c4.877,11.226,15.938,18.48,28.18,18.48c4.219,0,8.333-0.858,12.224-2.549
	c7.524-3.268,13.325-9.271,16.335-16.903c3.009-7.632,2.866-15.978-0.402-23.502c-2.079-4.786-3.178-11.014-3.218-17.948
	c4.815-0.325,9.809-0.774,15.009-1.36c16.099-1.814,30.083-4.427,42.133-7.899c3.399,5.583,6.141,12.361,5.594,17.966
	c-1.643,16.854,10.733,31.903,27.59,33.545c0.999,0.097,2.009,0.146,3.004,0.146c12.614,0,23.794-7.57,28.485-19.287
	c1.496-3.737-0.321-7.977-4.056-9.473c-3.737-1.496-7.977,0.321-9.473,4.056c-2.622,6.549-9.47,10.74-16.549,10.053
	c-4.29-0.418-8.161-2.482-10.899-5.811c-2.738-3.329-4.015-7.526-3.598-11.816c0.87-8.931-2.511-17.706-6.038-24.167
	c11.331-4.555,20.447-10.159,27.567-16.895c3.162,5.602,6.443,12.718,8.572,20.856c0.857,3.275,3.81,5.445,7.045,5.445
	c0.61,0,1.231-0.078,1.849-0.239c3.893-1.018,6.224-5,5.206-8.894c-3.154-12.058-8.423-22.128-12.837-29.11
	c6.375-10.179,9.238-21.661,10.165-33.682c13.235-3.766,26.534-12.694,35.077-23.826C411.253,319.15,409.39,304.989,399.542,297.432
	z M405.425,52.325c0.275-0.378,0.914-0.988,1.987-0.978l18.993,0.523c3.877,0.106,7.72-1.14,10.802-3.509l15.059-11.587
	c0.864-0.665,1.737-0.521,2.182-0.377c0.444,0.145,1.236,0.543,1.544,1.588l5.372,18.223c1.098,3.728,3.469,6.991,6.675,9.189
	l15.672,10.741c0.898,0.616,1.033,1.492,1.033,1.96c0,0.468-0.134,1.344-1.033,1.96l-15.673,10.741
	c-3.206,2.199-5.577,5.462-6.674,9.188l-1.524,5.173c-13.386-8.131-28.894-12.03-44.857-11.069l-7.331,0.439l3.824-10.753
	c1.303-3.663,1.303-7.696,0-11.357l-6.366-17.903C404.744,53.491,405.15,52.703,405.425,52.325z M42.055,389.474
	c-2.493-1.223-2.397-3.335-2.118-4.486c0.235-0.968,1.105-3.227,4.118-3.15c37.667,0.776,73.125-9.297,97.803-27.337
	c3.183,20.966,8.918,41.225,24.008,55.323c0.202,0.188,0.42,0.361,0.624,0.547C126.906,411.648,81.261,408.706,42.055,389.474z
	 M239.912,465.494c-1.581,4.011-4.629,7.165-8.584,8.883c-2.049,0.891-4.209,1.342-6.417,1.342c-6.436,0-12.25-3.812-14.814-9.713
	c-4.852-11.168-7.323-24.636-7.178-38.626c8.84,1.746,18.764,2.623,29.901,2.623c0.81,0,1.636-0.012,2.458-0.02
	c0.08,7.194,1.113,15.548,4.421,23.163C241.419,457.098,241.493,461.484,239.912,465.494z M224.439,279.476
	c-4.017,0.241-7.079,3.692-6.839,7.709c0.241,4.016,3.682,7.071,7.709,6.839l118.514-7.098c4.632,9.114,7.556,18.863,8.703,29.044
	c3.182,28.249,3.075,48.828-7.275,64.12c-0.415,0.613-0.849,1.214-1.297,1.81c-0.043,0.053-0.085,0.107-0.125,0.161
	c-7.26,9.574-18.814,16.956-35.307,22.41c-0.498,0.104-0.989,0.259-1.465,0.471c-12.001,3.818-26.524,6.659-43.83,8.609
	c-7.223,0.813-14.002,1.363-20.371,1.658c-0.229-0.001-0.455,0.01-0.679,0.029c-17.473,0.761-31.787-0.455-43.301-3.722
	c-0.464-0.194-0.953-0.344-1.463-0.44c-1.277-0.39-2.52-0.805-3.727-1.247c-0.319-0.15-0.652-0.271-0.992-0.374
	c-6.7-2.581-12.299-5.997-16.879-10.277c-10.003-9.346-17.065-22.792-21.357-60.893c-2.008-17.829,1.588-35.478,10.387-51.427
	c8.019,3.461,16.578,5.918,25.53,7.197c0.35,0.051,0.697,0.075,1.041,0.075c3.568,0,6.684-2.622,7.204-6.256
	c0.569-3.983-2.198-7.675-6.182-8.245c-40.547-5.798-71.757-39.732-74.21-80.689l-2.88-48.084
	c-1.556-25.992,7.102-51.035,24.38-70.515c17.279-19.479,41.109-31.065,67.101-32.622l40.626-2.433
	c30.699-1.837,60.043,11.744,78.507,36.333c14.58,19.416,37.757,30.141,61.991,28.69l27.899-1.671
	c34.754-2.078,64.734,24.504,66.816,59.265l1.961,32.725c2.081,34.761-24.505,64.734-59.265,66.816L224.439,279.476z
	 M392.136,320.126c-5.719,7.452-14.416,13.781-23.258,17.246c-0.191-5.588-0.641-11.22-1.206-16.825
	c3.716-2.028,8.122-5.207,11.866-10.088c2.665-3.473,7.659-4.13,11.132-1.465C394.143,311.659,394.8,316.653,392.136,320.126z
	 M26.833,293.005c0.492,0.233,0.892,0.632,1.125,1.125l8.157,17.16c2.401,5.05,7.132,8.588,12.655,9.463
	c0.886,0.141,1.773,0.209,2.654,0.209c4.617,0,9.078-1.889,12.307-5.299l13.059-13.799c0.375-0.396,0.879-0.653,1.419-0.724
	l18.84-2.455c5.546-0.723,10.372-4.129,12.911-9.111c2.539-4.983,2.458-10.89-0.218-15.801l-9.088-16.686
	c-0.26-0.478-0.349-1.036-0.249-1.572l3.487-18.677c1.026-5.498-0.722-11.141-4.676-15.095c-3.955-3.954-9.596-5.704-15.095-4.676
	l-18.678,3.487c-0.534,0.1-1.093,0.012-1.572-0.249l-16.685-9.088c-4.912-2.675-10.818-2.756-15.801-0.218
	s-8.389,7.365-9.112,12.911l-2.455,18.84c-0.071,0.541-0.327,1.044-0.723,1.418L5.298,257.232c-4.061,3.843-5.964,9.437-5.089,14.96
	c0.875,5.524,4.413,10.255,9.464,12.655L26.833,293.005L26.833,293.005z M15.929,271.687c-0.983-0.467-1.253-1.313-1.326-1.774
	c-0.073-0.461-0.078-1.348,0.713-2.097l13.8-13.06c2.821-2.671,4.653-6.265,5.156-10.119l2.455-18.84
	c0.141-1.08,0.861-1.597,1.277-1.809c0.416-0.214,1.257-0.491,2.214,0.03l16.685,9.088c3.413,1.859,7.396,2.491,11.217,1.777
	l18.677-3.487c1.065-0.201,1.785,0.324,2.115,0.656c0.33,0.33,0.855,1.045,0.656,2.115l-3.487,18.677
	c-0.713,3.821-0.083,7.804,1.777,11.217l9.088,16.685c0.521,0.956,0.243,1.798,0.03,2.214c-0.212,0.417-0.729,1.136-1.809,1.277
	l-18.841,2.455c-3.853,0.502-7.446,2.334-10.119,5.156l-13.059,13.799c-0.749,0.792-1.635,0.786-2.098,0.713
	c-0.461-0.073-1.306-0.343-1.774-1.326l-8.157-17.16c-1.668-3.51-4.521-6.362-8.031-8.031L15.929,271.687z M381.197,147.495
	c3.976-0.238,7.005-3.654,6.767-7.629c-0.238-3.975-3.653-7.005-7.629-6.767c-3.975,0.238-7.005,3.653-6.767,7.629
	C373.806,144.704,377.221,147.733,381.197,147.495z M431.545,237.67c5.488-6.187,8.238-14.14,7.744-22.396l-0.601-10.03
	c-0.334-5.576-2.819-10.688-6.998-14.394c-4.18-3.706-9.551-5.563-15.127-5.231l-20.06,1.202
	c-5.576,0.334-10.688,2.819-14.394,6.998s-5.564,9.551-5.231,15.127l0.6,10.03c0.495,8.255,4.174,15.825,10.362,21.312
	c5.713,5.067,12.931,7.8,20.503,7.8c0.629,0,1.259-0.019,1.893-0.056C418.489,247.536,426.058,243.857,431.545,237.67z M420.643,228
	c-2.905,3.275-6.911,5.222-11.281,5.483c-4.37,0.267-8.58-1.194-11.854-4.098c-3.275-2.905-5.222-6.911-5.484-11.28l-0.6-10.03
	c-0.209-3.49,2.46-6.498,5.949-6.708l20.06-1.201c0.128-0.008,0.256-0.012,0.383-0.012c3.324,0,6.123,2.6,6.324,5.961l0.601,10.03
	C425.004,220.516,423.548,224.725,420.643,228z M427.066,144.748c3.976-0.238,7.005-3.653,6.767-7.629
	c-0.238-3.976-3.653-7.005-7.629-6.767c-3.975,0.238-7.005,3.653-6.767,7.629C419.676,141.956,423.091,144.986,427.066,144.748z
	 M286.627,78.781c-3.8-3.37-8.682-5.064-13.753-4.756c-5.069,0.304-9.718,2.564-13.088,6.363c-3.37,3.8-5.059,8.684-4.756,13.753
	c0.232,3.869,3.441,6.851,7.267,6.851c0.146,0,0.294-0.004,0.442-0.013c4.017-0.241,7.079-3.692,6.839-7.709
	c-0.071-1.184,0.324-2.325,1.11-3.212c0.787-0.888,1.872-1.416,3.056-1.485c1.18-0.075,2.325,0.324,3.212,1.11
	c0.888,0.787,1.416,1.872,1.486,3.056c0.241,4.017,3.69,7.077,7.709,6.839c4.017-0.241,7.079-3.692,6.839-7.709
	C292.687,86.799,290.427,82.151,286.627,78.781z M206.282,83.593c-3.8-3.37-8.687-5.057-13.754-4.755
	c-10.465,0.628-18.469,9.651-17.843,20.116c0.232,3.869,3.441,6.851,7.267,6.851c0.146-0.001,0.294-0.005,0.442-0.014
	c4.017-0.241,7.079-3.692,6.839-7.709c-0.147-2.444,1.723-4.553,4.167-4.698c1.18-0.078,2.325,0.323,3.212,1.11
	c0.888,0.787,1.415,1.872,1.485,3.056c0.241,4.017,3.689,7.075,7.709,6.838c4.017-0.241,7.079-3.692,6.839-7.709
	C212.34,91.611,210.08,86.963,206.282,83.593z M233.072,362.83c2.166,1.355,4.236,2.241,6.251,3.104
	c6.299,2.696,8.568,4.249,9.585,8.127c2.593,9.896,11.544,16.808,21.766,16.808c1.924,0,3.848-0.249,5.719-0.74
	c12.007-3.149,19.215-15.479,16.067-27.486c-6.777-25.843-28.338-35.071-35.429-38.106l-0.431-0.183
	c-0.207-0.087-0.4-0.167-0.574-0.245c-2.131-1.196-4.421-2.032-6.814-2.486c-3.956-0.749-7.767,1.847-8.517,5.802
	c-0.749,3.953,1.848,7.767,5.802,8.517c0.882,0.167,1.728,0.485,2.513,0.944l0.057,0.033c0.007,0.005,0.015,0.009,0.022,0.014
	l0.159,0.098c0.589,0.365,1.21,0.637,1.845,0.819l0.209,0.089c6.611,2.829,22.092,9.455,27.06,28.401
	c1.11,4.234-1.432,8.584-5.668,9.694c-0.665,0.175-1.346,0.263-2.022,0.263c-3.601,0-6.754-2.439-7.669-5.93
	c-2.997-11.432-11.995-15.281-17.958-17.834c-1.629-0.698-3.035-1.299-4.243-2.055c-1.024-0.641-1.865-1.477-2.501-2.484
	c-2.147-3.402-6.644-4.421-10.051-2.274c-3.403,2.147-4.421,6.647-2.274,10.051C227.791,358.643,230.177,361.018,233.072,362.83z"
    />
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
</template>

<style></style>
